import React, { useEffect, Suspense, lazy } from "react"
import PropTypes from "prop-types"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { Row, Col } from "antd"

import { APP_PAGES } from "../../../../../data/config/constants"
import { pageChanged } from "../../../../../data/redux/page_details/actions"
import { log } from "../../../../../data/config/utils"
import { getIsMobile } from "../../../../../data/redux/page_details/selectors"

import SpinnerLoader from "../../../../../components/spinnerloader"

const ReportsList = lazy(() => import("./ReportsList"))
const ReportDetails = lazy(() => import("./ReportDetails"))
const ErrorBoundary = lazy(() => import("../../../../../components/errorboundary"))

const Reports = ({
  actions,
  is_mobile
}) => {
  log("Reports rendered")
  const { pageChanged } = actions

  useEffect(() => {
    pageChanged(APP_PAGES.REPORTS, APP_PAGES.CONSOLE)
  }, [])

  return (
    <Row className="ori-bg-white ori-full-parent-height">
      <Col
        xs={24}
        md={5}
        id="reportsContainer"
        className="ori-r-border-light ori-full-parent-height ori-flex-column"
      >
        <Suspense fallback={<SpinnerLoader text="Loading" />}>
          <ErrorBoundary>
            <ReportsList />
          </ErrorBoundary>
        </Suspense>
      </Col>
      {
        !is_mobile &&
        <Col
          xs={24}
          md={19}
          className="ori-full-parent-height ori-overflow-auto"
        >
          <Suspense fallback={<SpinnerLoader text="Loading" />}>
            <ErrorBoundary>
              <ReportDetails />
            </ErrorBoundary>
          </Suspense>
        </Col>
      }
    </Row>
  )
}

const mapStateToProps = state => {
  return {
    is_mobile: getIsMobile(state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      pageChanged,
    },
    dispatch
  )
})

Reports.propTypes = {
  actions: PropTypes.object,
  is_mobile: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports)



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/console/reports/index.js